<template>
    <div class="ads table-body" v-if="hasLoaded">
        <facebook-ads-table-row v-for="ad in ads"
                                type="ad"
                                :class="{'is-active': ad.id === selectedAd.id}"
                                :status="status"
                                :ad="ad"
                                :key="ad.id">
            <div class="row preview-container">
                <div class="preview" v-if="preview && ad.id === selectedAd.id" v-html="preview"/>
            </div>
        </facebook-ads-table-row>
    </div>
</template>

<script>
  import FacebookAdsTableRow from '@/app/facebook/components/ads/FacebookAdsTableRow'
  import { mapGetters } from 'vuex'
  import datepickerMixin from '@/app/datepicker/datepicker.mixin'

  export default {
    mixins: [datepickerMixin],
    data () {
      return {
        ads: [],
        hasLoaded: false
      }
    },

    props: {
      status: {
        type: String
      }
    },

    computed: {
      ...mapGetters('facebookAds', {
        selected: 'getSelected',
        metrics: 'getMetrics'
      }),
      selectedAd () {
        return this.selected(this.status).ad
      },
      preview () {
        return this.selected(this.status).preview
      }
    },

    watch: {
      metrics: {
        handler: 'load',
        immediate: true
      },

      ads () {
        if (this.ads.length > 0) {
          this.$store.dispatch('facebookAds/select', {
            object: this.ads[0],
            status: this.status,
            type: 'ad'
          })
        }
      },

      selectedAd () {
        if (!this.selectedAd) {
          return
        }

        this.$store.dispatch('facebookAds/setAdPreview', this.status)
      }
    },

    methods: {
      async load () {
        this.$emit('hasLoaded', false)
        this.hasLoaded = false
        this.ads = await this.$store.dispatch('facebookAds/loadAds', this.status)
        this.hasLoaded = true
        this.$emit('hasLoaded', true)
      }
    },

    components: {
      FacebookAdsTableRow
    }
  }
</script>

<style lang="scss" scoped>
    .preview-container {
        text-align: center;
        background: #ffffff !important;

        .preview {
            margin: 30px 0;
            display: inline-block;
        }
    }

    .is-active {
        background: #e9e9e9;

        .row-header {
            background: #e9e9e9;
        }

        .preview-container {
            border-top: 1px solid #dddddd;
            border-bottom: 1px solid #dddddd;
        }

        .row-preview {
            border: 1px solid #e9e9e9;
        }
    }
</style>
